import { Text } from "@ilc-technology/luik";
import Surface from "../Surface/Surface";
import React from "react";
import { forwardRef } from "react";
import { useDatasources } from "../../contexts/StoryblokContext/StoryblokContext";
import { LabelKey } from "../../Common/StoryblokTypes";

export interface TBSectionProps {
  title: string;
  children?: React.ReactNode;
  isUpgrade?: boolean;
  style?: React.CSSProperties;
  gap?: number;
}

export const Tag = ({ label }: { label: string }) => {
  return (
    <div className="flex w-full justify-start">
      <div className="mb-4 rounded bg-primary-accessible px-2 py-1 text-sm leading-4 text-white">{label}</div>
    </div>
  );
};

const TBSection = forwardRef<HTMLDivElement, TBSectionProps>(({ title, isUpgrade, children, style, gap = 6 }, ref) => {
  const { labels } = useDatasources();

  const tagLabel = labels[LabelKey.upgradeTag];

  return (
    <Surface style={isUpgrade ? { backgroundColor: "#E5F3FF" } : style}>
      {isUpgrade && tagLabel && <Tag label={tagLabel} />}
      <div className={`relative flex flex-col gap-${gap}`} ref={ref}>
        <Text variant="heading-5-bold">{title}</Text>
        {children}
      </div>
    </Surface>
  );
});

TBSection.displayName = "TBSection";

export default TBSection;
